import { useEffect, useMemo, useState } from "react";
import "./AdminRehabOccupancyModule.scss";
import { toast } from "react-toastify";
import { OccupancyStatisticsExport } from "../../../types/api";
import StatisticsFilterList from "../StatisticsFilterList/StatisticsFilterList";

import { createStatisticsFilterStore } from "../Stores/statisticsFilterStoreFactory";
import { ReportTableSection } from "../Tables/ReportTableSection";
import { MembertypeChart } from "../Charts/MembertypeChart";
import { GuestChart } from "../Charts/GuestChart";

interface AdminRehabOccupancyModuleProps {
  rehabOccupancyData: OccupancyStatisticsExport;
  rehabOccupancyFilterStore: ReturnType<typeof createStatisticsFilterStore>;
  startDate: string;
  endDate: string;
  selectedWeekdays: number[];
}

const AdminRehabOccupancyModule = ({
  rehabOccupancyData,
  rehabOccupancyFilterStore,
  startDate,
  endDate,
  selectedWeekdays,
}: AdminRehabOccupancyModuleProps) => {
  function countWeekdaysFromIntervals(startDate: Date, endDate: Date) {
    const counts = {
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
    };

    const start = new Date(
      Date.UTC(
        startDate.getUTCFullYear(),
        startDate.getUTCMonth(),
        startDate.getUTCDate()
      )
    );
    const end = new Date(
      Date.UTC(
        endDate.getUTCFullYear(),
        endDate.getUTCMonth(),
        endDate.getUTCDate()
      )
    );

    for (let d = new Date(start); d <= end; d.setUTCDate(d.getUTCDate() + 1)) {
      const dayOfWeek = d.getUTCDay(); // 0 = Sunday
      const isoDay = dayOfWeek;

      if (selectedWeekdays.includes(isoDay)) {
        switch (isoDay) {
          case 1:
            counts.monday++;
            break;
          case 2:
            counts.tuesday++;
            break;
          case 3:
            counts.wednesday++;
            break;
          case 4:
            counts.thursday++;
            break;
          case 5:
            counts.friday++;
            break;
          case 6:
            counts.saturday++;
            break;
          case 0:
            counts.sunday++;
            break;
        }
      }
    }

    return counts;
  }

  const [weekdayCounts, setWeekdayCounts] = useState({
    monday: 0,
    tuesday: 0,
    wednesday: 0,
    thursday: 0,
    friday: 0,
    saturday: 0,
    sunday: 0,
  });

  const totalDays = Object.values(weekdayCounts).reduce(
    (acc, count) => acc + count,
    0
  );
  useEffect(() => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const counts = countWeekdaysFromIntervals(start, end);
    setWeekdayCounts(counts);
  }, [startDate, endDate, selectedWeekdays]);
  const [chartType, setChartType] = useState<"line" | "pie">("line");

  return (
    <div className="admin-rehab-occupancy-module">
      <StatisticsFilterList
        useStore={rehabOccupancyFilterStore}
        useTimeintervals={true}
        useTypeOfBookings={false}
        usePermissions={true}
        useGender={true}
        useAgeGroups={true}
      />
      <ReportTableSection
        title="Beläggning - Rehab-bad"
        columns={[
          { key: "member_name", label: "Namn" },
          { key: "timespan", label: "Tidsperiod" },
          {
            key: "permission_id",
            label: `Medlemstyp`,
            align: "left",
          },
          {
            key: "bookings_count",
            label: `Antal bokningar`,
            align: "left",
          },
          {
            key: "available_count",
            label: `Tillgängliga slots`,
            align: "left",
          },
          {
            key: "total_count",
            label: `Totalt antal slots`,
            align: "left",
          },
          {
            key: "percentage_occupancy",
            label: `Utfall i procent`,
            align: "left",
          },
        ]}
        rows={rehabOccupancyData && rehabOccupancyData.data}
        useCalcType={false}
        useToggleType={false}
        onToggleType={(isPie: boolean) => setChartType(isPie ? "pie" : "line")}
        useStore={rehabOccupancyFilterStore}
        isLoading={false}
      />
      <div className="occupancy-spacer"> </div>
    </div>
  );
};
export default AdminRehabOccupancyModule;
